import { render, staticRenderFns } from "./ProjectAddSub.vue?vue&type=template&id=f8f31bf4&scoped=true&"
import script from "./ProjectAddSub.vue?vue&type=script&lang=js&"
export * from "./ProjectAddSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f31bf4",
  null
  
)

export default component.exports